module.exports = __webpack_public_path__ + "static/media/treatment-approaches.c9db0afa.svg";